var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotebooks = function SvgIconNotebooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    x: 1.5,
    y: 1.5,
    stroke: "currentColor",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    x: 1.5,
    y: 7.5,
    stroke: "currentColor",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 1.5,
    y: 11.5,
    stroke: "currentColor",
    rx: 0.5
  })));
};
export { SvgIconNotebooks as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS41IiB5PSIxLjUiIHdpZHRoPSIxMyIgaGVpZ2h0PSI0IiByeD0iMC41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSIxLjUiIHk9IjcuNSIgd2lkdGg9IjEzIiBoZWlnaHQ9IjIiIHJ4PSIwLjUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjEuNSIgeT0iMTEuNSIgd2lkdGg9IjEzIiBoZWlnaHQ9IjMiIHJ4PSIwLjUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";